module.exports = __webpack_public_path__ + "media/icon/icon-car-gray-dfe0b13b.svg";